import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteProfileAvatarMutation,
  useLogoutMutation,
} from '@common/cache';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { formatApiError } from '@common/errors/error-formatting.ts';
import { clearTokens } from '@store';

export const useDetailsCard = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const deleteImageMutation = useDeleteProfileAvatarMutation();
  const logoutMutation = useLogoutMutation();

  const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const handleDeleteConfirmationOpen = () => {
    setDeleteConfirmationOpen(true);
  };
  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmationOpen(false);
  };
  const confirmDelete = async () => {
    await deleteImageMutation.mutateAsync();
    handleDeleteConfirmationClose();
  };

  const [isSignoutConfirmationOpen, setSignoutConfirmationOpen] =
    useState(false);
  const handleSignoutConfirmationOpen = () => {
    setSignoutConfirmationOpen(true);
  };
  const handleSignoutConfirmationClose = () => {
    setSignoutConfirmationOpen(false);
  };
  const confirmSignout = async () => {
    try {
      await logoutMutation.mutateAsync();
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      clearTokens();
      localStorage.clear();
      navigate('/auth/login');
      queryClient.removeQueries();
    }
  };

  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const openUpload = () => {
    setIsUploadOpen(true);
  };
  const closeUpload = () => {
    setIsUploadOpen(false);
  };

  return {
    isDeleteConfirmationOpen,
    handleDeleteConfirmationOpen,
    handleDeleteConfirmationClose,
    confirmDelete,
    isSignoutConfirmationOpen,
    handleSignoutConfirmationOpen,
    handleSignoutConfirmationClose,
    confirmSignout,
    isUploadOpen,
    openUpload,
    closeUpload,
  };
};
